export default __webpack_public_path__ + "static/media/undraw_Contract_re_ves9.09d306dc.svg";